<template>
  <ais-instant-search
    :search-client="searchClient"
    :index-name="this.getGlobalIndexName()"
  >
    <ais-configure :query="this.queryString" />

    <base-header class="pb-5">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7"></div>
        <div class="col-lg-6 col-5 text-right"></div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <div class="col-12 card-wrapper">
          <ais-autocomplete>
            <!-- Search box -->
            <div slot-scope="{ currentRefinement, indices, refine }">
              <div class="navbar-search navbar-search-light form-inline mr-sm-3" id="search-main">
                <div class="form-group mb-0">
                  <div class="input-group input-group-alternative input-group-merge">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fas fa-search"></i>
                      </span>
                    </div>

                    <input
                      class="form-control"
                      type="text"
                      placeholder="Search"
                      v-model="queryString"
                      @input="refine($event.currentTarget.value)"
                    />
                  </div>
                </div>
                <button
                  type="button"
                  class="close"
                  data-action="search-close"
                  data-target="#search-main"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <!-- / Search box -->

              <ais-state-results>
                <div slot-scope="{ query, hits }" class="pt-5">
                  
                  <div>
                    <ais-hits>
                      <div slot-scope="{ items }">
                        <div class="card">
                          <el-table
                            class="table-responsive table-flush"
                            header-row-class-name="thead-light"
                            :data="hits"
                          >

                          <el-table-column label="Type" min-width="180px" prop="type" sortable>
                              <template v-slot="{row}">
                                  <div class="media align-items-center">
                                    <a class="mr-3">
                                      <i
                                        v-if="row.objectID.includes('Lead')"
                                        class="ni ni-single-02 text-default"
                                      ></i>
                                      <i
                                        v-if="row.objectID.includes('Application')"
                                        class="ni ni-single-copy-04 text-default"
                                      ></i>
                                    </a>
                                    <div class="media-body">
                                      <span
                                        v-if="row.objectID.includes('Lead')"
                                        class="font-weight-600 name mb-0 text-sm"
                                      >Lead</span>
                                      <span

                                        v-if="row.objectID.includes('Application')"
                                        class="font-weight-600 name mb-0 text-sm"
                                      >Application</span>
                                    </div>
                                  </div>
                              </template>
                            </el-table-column>

                            <el-table-column label="Name" min-width="250px" prop="name" sortable>
                              <template v-slot="{row}">
                                <div class="media align-items-center">
                                  <div class="media-body">
                                    <span class="font-weight-600 name mb-0 text-sm">{{row.name}}</span>
                                  </div>
                                </div>
                              </template>
                            </el-table-column>

                            <el-table-column label="Email" min-width="300px" prop="email" sortable>
                              <template v-slot="{row}">
                                <div class="media align-items-center">
                                  <div class="media-body">
                                    <span class="font-weight-600 name mb-0 text-sm">{{row.email}}</span>
                                  </div>
                                </div>
                              </template>
                            </el-table-column>

                            <el-table-column label="Company Name" min-width="250px" prop="company_name" sortable>
                              <template v-slot="{row}">
                                <div class="media align-items-center">
                                  <div class="media-body">
                                    <span class="font-weight-600 name mb-0 text-sm">{{row.company_name}}</span>
                                  </div>
                                </div>
                              </template>
                            </el-table-column>

                            <el-table-column prop="link" min-width="140px">
                              <template v-slot="{row}">
                                <base-button
                                  @click.native="handleLink(row.objectID)"
                                  class="btn-link"
                                  type="warning"
                                  size="sm"
                                  icon
                                >
                                  <i class="text-white fas fa-search"></i>
                                </base-button>
                              </template>
                            </el-table-column>
                          </el-table>
                        </div>
                      </div>
                    </ais-hits>
                  </div>
                </div>
              </ais-state-results>
            </div>
          </ais-autocomplete>
        </div>
      </div>
    </div>
  </ais-instant-search>
</template>
<script>
import algoliasearch from "algoliasearch/lite";
import { Table, TableColumn } from "element-ui";

export default {
  name: "Search",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      searchClient: algoliasearch(
        process.env.VUE_APP_ALGOLIA_APP_KEY,
        process.env.VUE_APP_GLOBAL_ALGORIA_SEARCH_KEY
      ),
      queryString: '',
    };
  },
  created() {
    this.queryString = this.$route.query.q == undefined ? '' : this.$route.query.q;    
  },
  methods: {
    handleLink(objectID){
      let id = objectID.split("::")[1];

      if (objectID.includes("Lead")) {
        this.$router.push(`/leads/${id}`).catch(error => {
          console.log(error);
        });
      } else if (objectID.includes("Application")) {
        this.$router.push(`/applications/${id}`).catch(error => {
          console.log(error);
        });
      }
    },
    getGlobalIndexName() {
      let env = process.env.NODE_ENV === 'production' ? 'prod' : 'dev';
      return env + "_global_search";
    }
  },
};
</script>
<style></style>
